import { Radio } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";

const StyledRadio = styled(Radio)(({ theme }) => ({
  color: theme.palette.grey.main,
}));

export default StyledRadio;
